import { IAccount } from '../../types/account';
import { ITransaction } from '../../types/transaction';
import { SET_BURNING_ACCOUNT, SET_BURNING_TRANSACTIONS } from './constants';

export const setBurningAccountAction = (account: IAccount) => ({
  type: SET_BURNING_ACCOUNT,
  payload: { account },
});

export const setBurningTransactions = (list: ITransaction[]) => ({
  type: SET_BURNING_TRANSACTIONS,
  payload: { list },
});
